exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc-rental .success-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background-color: #ececec;\n}\n.pc-rental .success-page h1 {\n  font-size: 48px;\n}\n.pc-rental .success-page p {\n  font-size: 20px;\n  color: #9B9B9B;\n}\n.pc-rental .success-page .btn {\n  margin-top: 30px;\n}", ""]);

// exports
